export const colors = {
    primary: '#8C52FF',
    secondary: '#EBEBEB'  
}

export const stylesMain = {
    fontSize: '17px'
}

